import { GetAllUsersForAdminState } from './getAllUsersForAdmin.types'

const initialState: GetAllUsersForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
